import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../style/star-rating.scss';

export class StarRating extends Component {
	constructor(props) {
		super(props);

		this.state = {
			rating: props.rating ? props.rating : 0,
			numberOfItems: props.numberOfItems ? props.numberOfItems : 5,
			isDirty: true
		};
    }

    starClicked(value) {
        this.setState({ rating: value });
        if(this.props.starClicked) this.props.starClicked(value);
	}

	componentDidUpdate() {
		// if(this.props.rating !== undefined && this.state.isDirty) {
		// 	this.setState({rating: this.props.rating});
		// }
	}

	render() {
		const ratingItems = [];

		for (let i = 1; i < this.state.numberOfItems + 1; i++) {
			if (this.state.rating >= i) {
				const newItem = (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20px"
						height="20px"
						key={`star.rating.item.${i}`}
						onClick={() => this.starClicked(i)}
                        className="svg-star"
					>
						<polygon points="10,1 4,18 19,6 1,6 16,18" fill="#894866" />
					</svg>
				);
				ratingItems.push(newItem);
			} else {
				const newItem = (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20px"
						height="20px"
						key={`star.rating.item.${i}`}
						onClick={() => this.starClicked(i)}
                        className="svg-star"
					>
						<polygon points="10,1 4,18 19,6 1,6 16,18" fill="#CDCDCD" />
					</svg>
				);
				ratingItems.push(newItem);
			}
		}

		return (
			<div className="ratings-container">
				{[...ratingItems]}
				<div>{this.state.rating}</div>
			</div>
		);
	}
}

StarRating.propTypes = {
    rating: PropTypes.number,
	starClicked: PropTypes.func,
	numberOfItems: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/album-view/components/star-rating.jsx